<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                    <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                    <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-breadcrumb/>
                    </nav>
                </b-col>
            </b-row>
        </base-header> 
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card>
                            <div slot="header">
                                <h3>{{language_terms['UPLOAD_RFIDS']}} </h3>
                            </div>
                            <b-row>
                                <b-col cols="12">
                                    <dropzone id="myVueDropzone" 
                                                ref="myVueDropzone" 
                                                class="mb-2" 
                                                :options="dropzoneOptions" 
                                                v-on:vdropzone-sending="sendingFile" 
                                                v-on:vdropzone-removed-file ="removeFile" 
                                                > 
                                        <input type="hidden" name="token" value="xxx">
                                    </dropzone>
                                </b-col>
                                
                            </b-row>
                            
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <b-modal v-model="prompt_modal" :header-bg-variant="'primary'"  centered class="my-modal" hide-footer>
            <template #modal-title>
                <span style="color: white">{{language_terms['ALERT']}}</span>
            </template>
            <b-row>
                <b-col cols="12">
                    <div>Number of RFIDS created :  <span style="color:green">{{created_count}}</span> </div>
                    <div>Number of RFIDS not created :  <span style="color:green">{{not_created_count}}</span> </div>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>
<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

// Import date picker css
import Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import { authHeader } from '../../global';
import axios from 'axios'
import {apiRoutes} from "../../apiRoutes"

export default {
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            rfid_filter: state => state.rfids.rfid_filter,
        })
    },
    components:{
        Loading,
        Dropzone
    },
    data(){
        return{
            created_count:0,
            not_created_count:0,
            prompt_modal:false,
            loading:false,
            dropzoneOptions: 
            {
                maxFiles: 1,
                url: "https://httpbin.org/post",
                thumbnailWidth: 200,
                addRemoveLinks: false,
                maxFilesize: 20,
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer '+ localStorage.access_token
                    }
            },
        }
    },
    methods:{
        async sendingFile(file, xhr, formData)
        {
            this.loading = true

            let vm = this
            let apiUrl = apiRoutes['UPLOAD_RFID_FILE']
            await axios.post(apiUrl, formData, authHeader()).then(res => 
            {
                    if (res.data.code == 1)
                    {
                        vm.$refs.myVueDropzone.removeFile(file)
                        vm.not_created_count = res.data.data.not_created_count
                        vm.created_count = res.data.data.created_count
                        vm.prompt_modal = true
                        this.loading = false
                    }
                    else
                    {
                        alert(res.data.msg)
                        vm.$refs.myVueDropzone.removeFile(file)
                    }
                })
                .catch(function()
                {
                    console.log('FAILUREAV!!');
                });

            this.loading = false
        },
        removeFile()
        {

        }
    }

}
</script>
